import { render, staticRenderFns } from "./payrollDetails.vue?vue&type=template&id=6be0408a&scoped=true"
import script from "./payrollDetails.vue?vue&type=script&lang=js"
export * from "./payrollDetails.vue?vue&type=script&lang=js"
import style0 from "./payrollDetails.vue?vue&type=style&index=0&id=6be0408a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0408a",
  null
  
)

export default component.exports